import React, { useState } from "react";
import styles from "./ExternalRolesConfig.module.scss";
import CustomTableWithPagination from "../../reusable-components/CustomTable";
import TNButton from "../../reusable-components/TNButton";
import {
  ButtonShape,
  ButtonSize,
  ButtonType,
  CommonButtonTexts,
} from "../../enums/ButtonAttributesEnums";
import {
  ADD_ROLE_BUTTON_TEXT,
  addRoleValidation,
  DELETE_ROLE_MSG,
  getExternalRolesColumns,
} from "./constants";
import Form from "../Form";
import AddRoleModal from "./AddRoleModal";
import RolesServices from "../../services/roles.services";
import TNLoader from "../../reusable-components/TNLoader";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "../../constants/QueryKeys";
import { message } from "antd";

export const ExternalRolesConfig = () => {
  const queryClient = useQueryClient();
  const { FetchExternalRolesList, DeleteExternalRoleEntry } = RolesServices();
  const { data, isFetching } = FetchExternalRolesList();
  const { mutateAsync: deleteRole, isPending } = DeleteExternalRoleEntry();
  const [isAddRoleModalOpen, setIsAddRoleModalOpen] = useState<boolean>(false);
  const [selectedRoleId, setSelectedRoleId] = useState<string>("");
  const [selectedRoleEdit, setSelectedRoleEdit] = useState<string | undefined>(
    undefined,
  );
  const handleAddRoleModalOpen = () => setIsAddRoleModalOpen(true);
  const handleAddRoleModalClose = () => {
    setSelectedRoleId("");
    setSelectedRoleEdit(undefined);
    setIsAddRoleModalOpen(false);
  };

  const handleRecordDelete = async (roleId: string) => {
    await deleteRole(roleId, {
      onSuccess: () => {
        message.success(DELETE_ROLE_MSG);
        queryClient.invalidateQueries([QueryKeys.FETCH_EXTERNAL_ROLES_KEY]);
      },
    });
  };

  const columns = getExternalRolesColumns({
    handleEditAction: (record) => {
      setSelectedRoleId(record?.id);
      setSelectedRoleEdit(record?.roleName);
      handleAddRoleModalOpen();
    },
    handleDeleteAction: (record) => {
      handleRecordDelete(record?.id);
    },
  });

  return (
    <>
      <TNLoader isLoading={isPending} />
      <Form validationSchema={addRoleValidation}>
        {() => (
          <AddRoleModal
            isOpen={isAddRoleModalOpen}
            handleClose={handleAddRoleModalClose}
            roleId={selectedRoleId}
            roleName={selectedRoleEdit}
          />
        )}
      </Form>
      <CustomTableWithPagination
        data={data}
        columns={columns}
        loading={isFetching}
        showPagination={false}
      />
      <TNButton
        text={ADD_ROLE_BUTTON_TEXT}
        className={styles.addRoleButton}
        type={ButtonType.PRIMARY}
        size={ButtonSize.LARGE}
        shape={ButtonShape.DEFAULT}
        onClick={handleAddRoleModalOpen}
      />
    </>
  );
};
